module.exports = __webpack_public_path__ + "static/media/IKEA Effect.ce817c7f.jpg";